<template>
  <div v-bind:class="this.getZoneFinalInconsistency(zone)" class="zoneFinal">
    <div
      class="columns is-mobile optionsContainer"
      v-bind:class="getZoneFinalInconsistency(zone)"
    >
      <div
        class="column"
        style="cursor: pointer"
        @click="
          $router.push(
            '/installations/' +
              installation['.key'] +
              '/zone/' +
              zone.path.split('/')[zone.path.split('/').length - 1] +
              '/edit'
          )
        "
      >
        <span class="icon clickable">
          <i class="mdi mdi-pencil"></i>
        </span>
      </div>
      <div
        v-if="!isFloor"
        class="column"
        style="cursor: pointer"
        @click="
          $router.push(
            '/installations/' +
              installation['.key'] +
              '/zone/' +
              zone.path.split('/')[zone.path.split('/').length - 1] +
              '/settings'
          )
        "
      >
        <img src="/home/images/zones/btn_ajustes.png" />
      </div>
    </div>

    <zone-final-thermostat
      v-if="devicesAreLoaded"
      id="thermostat"
    ></zone-final-thermostat>
    <div v-else>
      <h2 class="zoneName">
        <span class="icon clickable returnIcon" @click="goParent()">
          <i class="mdi mdi-chevron-left"></i>
        </span>
        {{ zone.name }}
      </h2>
    </div>

    <div class="text" v-if="zone.type === undefined">
      {{ $t("zone.undefinedType") }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ZoneFinalThermostat from "./ZoneFinalThermostat";
import { EventBus } from "../../../../util/event-bus";
import colors from "@/mixins/colors";
import constants from "@/config/constants";

export default {
  components: { ZoneFinalThermostat },
  name: "zone-final",
  mixins: [colors],

  data() {
    return {
      devicesHelp: {},
      devicesAreLoaded: false,
    };
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
      tariff: "currentTariff",
    }),

    ...mapState("zones", {
      devices: "devices",
      zone: "current",
    }),

    isFloor: function () {
      return this.zone.type === constants.zoneTypes.floor;
    },
  },

  methods: {
    ...mapActions("zones", ["setDevices", "setDevicesFinal"]),

    goParent: function () {
      let zoneArray = this.zone.path
        .split("/zones/")
        .filter(
          (idZone) =>
            idZone.length > 0 &&
            idZone !==
              this.zone.path.split("/")[this.zone.path.split("/").length - 1]
        );
      let path = "/installations/" + this.installation[".key"];
      if (zoneArray.length > 0)
        path += "/zone/" + zoneArray[zoneArray.length - 1];
      this.$router.push(path);
    },

    getDevices() {
      const zoneHelp = JSON.parse(JSON.stringify(this.zone));
      if (zoneHelp.zones) {
        for (const [key, value] of Object.entries(zoneHelp.zones)) {
          this.allDevices(value);
        }
      }
    },

    allDevices(zone) {
      for (const device in zone.devices) {
        if (zone.zones) {
          for (const [key, value] of Object.entries(zone.zones)) {
            this.allDevices(value);
          }
        } else {
          this.devicesHelp[device] = true;
        }
      }
    },
  },

  watch: {
    zone: function () {
      if (this.zone.devices) {
        this.setDevices();
      } else {
        this.getDevices();
        this.setDevicesFinal(this.devicesHelp);
      }
    },
  },

  mounted() {
    if (this.zone.devices) {
      this.setDevices().then(() => (this.devicesAreLoaded = true));
      EventBus.$on("deviceUpdate", () => this.$forceUpdate());
    } else {
      this.getDevices();
      this.setDevicesFinal(this.devicesHelp).then(
        () => (this.devicesAreLoaded = true)
      );
      EventBus.$on("deviceUpdate", () => this.$forceUpdate());
    }
  },
};
</script>

<style lang="scss" scoped>
.zoneFinal {
  background-color: #d584b5;
  min-height: calc(100% - 9.3rem);
}

.zoneName {
  padding-top: 5rem;
  padding-bottom: 1.5rem;
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
}

.optionsContainer {
  background-color: #d584b5;
  float: right;
  color: white;
  margin: 0rem 0 0 0;
  height: 3rem;

  .column {
    .icon .mdi {
      font-size: 22px;
    }
    width: 60px;
    flex-basis: 240px;
  }
  .column.active {
    opacity: 1;
  }
  img {
    height: 100%;
    /*padding: 0 30% 0 0;*/
  }
}
</style>
